const DEFAULT_CONFIG = {
  left: true,
  right: true,
};

const findChildNodeWithContent = (childNode: Node) => childNode.nodeName.toLowerCase() !== 'br';

// Function is used to remove <br> from start / end
const removeEmptyNodes = (node: Element | Node, config = DEFAULT_CONFIG) => {
  // Text Node
  if (node.nodeType === 3) {
    return;
  }

  const childNodes = Array.from(node.childNodes);
  const firstContentNodeIndex = childNodes.findIndex(findChildNodeWithContent);
  const reversedLastContentNodeIndex = [...childNodes]
    .reverse()
    .findIndex(findChildNodeWithContent);
  const lastContentNodeIndex = childNodes.length - 1 - reversedLastContentNodeIndex;

  childNodes.forEach((childNode, index) => {
    if (index === firstContentNodeIndex || index === lastContentNodeIndex) {
      removeEmptyNodes(childNode, {
        left: index === firstContentNodeIndex,
        right: index === lastContentNodeIndex,
      });
    } else if (config.left && index < firstContentNodeIndex) {
      childNode.remove();
    } else if (config.right && index > lastContentNodeIndex) {
      childNode.remove();
    }
  });
};

const parseMessage = (proseMirrorNode: Element) => {
  let message = '';

  if (proseMirrorNode.textContent) {
    const node = document.createElement('div');
    node.innerHTML = proseMirrorNode.innerHTML;
    removeEmptyNodes(node.children[0]);
    message = node.innerHTML;
  }

  return { message };
};

export default parseMessage;
